import { axiosClient } from "../api/httpClient";
import { deleteSpacesObjectByPublicUrl } from "../api/Util";

export async function clearRefThumbnailCommon({
  refThumbnailsFile,
  clientId,
  setState,
  setSelectedFile,
  setShowThumbnailsPre,
  clearPreviewOnEmpty = false,
}) {
  const current = refThumbnailsFile;

  if (!current) {
    if (setSelectedFile) {
      setSelectedFile(null);
    }
    if (clearPreviewOnEmpty && setShowThumbnailsPre) {
      setShowThumbnailsPre(false);
    }
    return;
  }

  try {
    deleteSpacesObjectByPublicUrl(current);

    await axiosClient.post("/api/user/uploadThumbnailFile", {
      ref_thumbnails_file: "",
      client_id: clientId,
    });

    if (setState) {
      setState((prev) => ({ ...prev, refThumbnailsFile: "" }));
    }

    if (setShowThumbnailsPre) {
      setShowThumbnailsPre(false);
    }

    if (setSelectedFile) {
      setSelectedFile(null);
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
}

